import * as React from 'react';

import type { ModuleLayoutConfig } from '@coursera-web/cds-labs';
import { ModuleLayout, noImage } from '@coursera-web/cds-labs';

import Skills from 'bundles/unified-description-page-common/components/modules/product-overview/Skills';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

// eslint-disable-next-line @coursera-web/custom-rules/i18n-import-rule
import _t from 'i18n!nls/xdp';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment;
};

const RelatedSpecializationSkillsModuleRenderer = ({ pageData }: Props) => {
  const renderContent = () => (
    <Skills
      title={_t('Explore more related skills')}
      titleTypographyVariant="titleSmall"
      skills={pageData.skills?.length ? pageData.skills : pageData.specializationAndCourseSkills}
      enableSkillsLinkingOverride={true}
      disableCTA={true}
    />
  );

  const assembly: ModuleLayoutConfig = {
    removeTopPadding: true,
    removeBottomPadding: true,
  };

  return <ModuleLayout renderContent={renderContent} assembly={noImage(assembly)} />;
};

export default RelatedSpecializationSkillsModuleRenderer;
